import Vue from 'vue'
import Router from 'vue-router'

import Landing from './components/Landing.vue'
import Home from './forms/Full.vue'
import Faq from './components/Faq.vue'
import Terms from './components/Terms.vue'
import Privacy from './components/Privacy.vue'
import Thanks from './components/Pass.vue'
import Early from './components/Early.vue'
import Late from './components/Late.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Landing,
      nav: true,
      navTitle: 'Home'
    },
    {
      path: '/form',
      name: 'form',
      component: Home,
      nav: true,
      navTitle: 'Form'
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      nav: true,
      navTitle: 'Faq'
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      nav: true,
      navTitle: 'T&Cs'
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      nav: true,
      navTitle: 'Privacy Policy'
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: Thanks,
      nav: true,
      navTitle: 'Thanks'
    },
    {
      path: '/soon',
      name: 'early',
      component: Early,
      nav: true,
      navTitle: 'early'
    },
    {
      path: '/sorry',
      name: 'Late',
      component: Late,
      nav: true,
      navTitle: 'late'
    },
    {
      path: '*',
      name: 'notfound',
      component: () => import(/* webpackChunkName: "late" */ './components/NotFound.vue'),
      nav: false,
      navTitle: '404 - Page Not Found'
    }
  ]
})

export default router;